import type { Collection } from 'state/utils/types';

export interface DynamicWorkspaceState {
  quoteId?: string;
  isFetchingTabContent: boolean;
  isChoosingProduct: boolean;
}

export type DynamicWorkspaceStateMap = Collection<DynamicWorkspaceState>;

export const initialDynamicWorkspaceState: DynamicWorkspaceStateMap = {};
